import React, { useEffect, useRef } from "react"
import moment from "moment"
import Button from "@/components/core/Button/Button"

import {
  getOfflineReviewProductsAnalytics,
  getProductConfirmationEventInfo,
} from "@/components/RegisterOfflineProduct/v1/RegisterOfflineHelper"
import styles from "@/components/RegisterOfflineProduct/v1/RegisterProductConfirmation/index.module.scss"
import DOMPurify from "isomorphic-dompurify"
const RegisterProductConfirmation = ({
  staticText,
  myProductsPath,
  customerDetails: {
    phone = {},
    email = {},
    firstName = {},
    lastName = {},
    address = {},
    city = {},
    state = {},
    pinCode = {},
  },
  productDetails = [],
}) => {
  const regConfirmRef = useRef()

  useEffect(() => {
    const offlileConfirmation = regConfirmRef.current
    offlileConfirmation.focus()
  }, [])
  console.log(productDetails, "prodeDetails")
  return (
    <div className={`${styles.registerProductConfirmationWrapper}`}>
      <div className="registration-confirmation">
        <div className="product-confirmation-section">
          <div className="container kf-react-container">
            <div className="row mx-0 px-0">
              <div
                id="register-offline-confirmation"
                className="col-12 product-confirmation-section-container"
                role="status"
                tabIndex="0"
                ref={regConfirmRef}
              >
                <div className="content-left">
                  {staticText.confirmationMainCopy && (
                    <div
                      className="confirmation-main-copy"
                      dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(
                          staticText.confirmationMainCopy(productDetails.length)
                        ),
                      }}
                    ></div>
                  )}
                  <div
                    className="confirmation-sub-copy"
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(
                        staticText.confirmationSubCopy
                      ),
                    }}
                  ></div>
                </div>
                <div className="content-right">
                  <Button
                    className="gbh-data-layer"
                    data-gbh-data-layer={getOfflineReviewProductsAnalytics(
                      myProductsPath,
                      productDetails
                    )}
                    label={staticText.backToHome}
                    to={myProductsPath}
                    type="black"
                    useDefaultClass
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="product-summary-section">
          <div className="container kf-react-container">
            <div className="row mx-0 px-0">
              <div className="col-12 px-0">
                <div className="product-summary-title">
                  {staticText.productRegistrationSummary}
                </div>
                <div className="product-summary-list">
                  <div className="registration-information-review">
                    <div className="title">
                      {staticText.registrationInformationTitle}
                    </div>
                    <div className="registration-data">
                      <div>{`+91 ${phone?.value}`}</div>
                      <div>{email?.value}</div>
                      <div>
                        {firstName.value} {lastName.value}
                      </div>
                      <div>{address.value}</div>
                      <div>
                        {pinCode.value}, {city.value}, {state.value}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="product-summary-list">
                  <div className="registration-information-review">
                    <div className="title">{`Products Registered ${moment(
                      productDetails[0]?.dateOfPurchase?.value
                    )?.format("DD/MM/YYYY")}`}</div>
                    <div className="product-info-result">
                      <ul>
                        {productDetails.map((item, i) => {
                          return (
                            <li key={i}>
                              <div className="product-data">
                                <div>{item.productDetails?.value}</div>
                                <div>{item.serialNumber?.value}</div>
                                <div>{item.dealerName?.value}</div>
                                <div>
                                  {moment(item.dateOfPurchase?.value)?.format(
                                    "DD/MM/YYYY"
                                  )}
                                </div>
                              </div>
                            </li>
                          )
                        })}
                      </ul>
                    </div>
                  </div>
                </div>

                <Button
                  className="custom-button-width gbh-data-layer"
                  data-gbh-data-layer={getProductConfirmationEventInfo(
                    myProductsPath,
                    productDetails
                  )}
                  label={staticText.backToHome}
                  to={myProductsPath}
                  type="black"
                  useDefaultClass
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default RegisterProductConfirmation
